var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassMenu",
    {
      attrs: {
        placement: "top-start",
        trigger: "click",
        "custom-class": "custom-menu-container",
        disabled: _vm.disabled
      },
      scopedSlots: _vm._u([
        {
          key: "dropdown",
          fn: function() {
            return [
              _vm._l(_vm.allCustomSize, function(size, indexSize) {
                return _c(
                  "CompassMenuItem",
                  {
                    key: indexSize,
                    staticClass: "custom-menu-item",
                    on: {
                      click: function($event) {
                        _vm.getExtensionOption("Size").action(size)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [_vm._v(" " + _vm._s(size) + "px ")]
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("UnSize").action()
                    }
                  }
                },
                [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-small-regular" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(_vm.getExtensionOption("UnSize").label)
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.$t.__(_vm.getExtensionOption(_vm.option).label),
            placement: "top",
            delay: { show: 0, hide: 1 },
            disabled: _vm.disabled
          }
        },
        [
          _c("CompassIconButton", {
            attrs: {
              icon: _vm.getExtensionOption(_vm.option).icon,
              size: "small",
              disabled: _vm.disabled,
              active: _vm.activeStyle(_vm.option),
              "show-dropdown": ""
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }